// extracted by mini-css-extract-plugin
export default {"card":"styles_card__GD2oM","field":"styles_field__ExTEO"};